type TBank = {
  src: string
  alt: string
  name: string
  isShow: boolean
  xenditChannelCode: string | null
}

const bankList: Record<string, TBank> = {
  anz: {
    src: '/assets/bank/anz.png',
    alt: 'anz',
    name: 'Bank ANZ',
    isShow: false,
    xenditChannelCode: null,
  },
  applepay: {
    src: '/assets/bank/applepay.png',
    alt: 'applepay',
    name: 'Apple Pay',
    isShow: false,
    xenditChannelCode: null,
  },
  bank_syariah_indonesia: {
    src: '/assets/bank/bank_syariah_indonesia.png',
    alt: 'bank_syariah_indonesia',
    name: 'Bank Syariah Indonesia (BSI)',
    isShow: false,
    xenditChannelCode: null,
  },
  bca: {
    src: '/assets/bank/bca.png',
    alt: 'bca',
    name: 'BCA',
    isShow: true,
    xenditChannelCode: 'BCA',
  },
  bjb: {
    src: '/assets/bank/bjb.png',
    alt: 'bjb',
    name: 'Bank Jawa Barat (BJB)',
    isShow: false,
    xenditChannelCode: null,
  },
  bluepay: {
    src: '/assets/bank/bluepay.png',
    alt: 'bluepay',
    name: 'Bluepay',
    isShow: false,
    xenditChannelCode: null,
  },
  bni: {
    src: '/assets/bank/bni.png',
    alt: 'bni',
    name: 'BNI',
    isShow: true,
    xenditChannelCode: 'BNI',
  },
  bri: {
    src: '/assets/bank/bri.png',
    alt: 'bri',
    name: 'BRI',
    isShow: true,
    xenditChannelCode: 'BRI',
  },
  btn: {
    src: '/assets/bank/btn.png',
    alt: 'btn',
    name: 'Bank Tabungan Negara (BTN)',
    isShow: false,
    xenditChannelCode: null,
  },
  bukopin: {
    src: '/assets/bank/bukopin.png',
    alt: 'bukopin',
    name: 'Bank Bukopin',
    isShow: false,
    xenditChannelCode: null,
  },
  cashbac: {
    src: '/assets/bank/cashbac.png',
    alt: 'cashbac',
    name: 'Cashbac',
    isShow: false,
    xenditChannelCode: null,
  },
  cashlez: {
    src: '/assets/bank/cashlez.png',
    alt: 'cashlez',
    name: 'Cashlez',
    isShow: false,
    xenditChannelCode: null,
  },
  cimb: {
    src: '/assets/bank/cimb.png',
    alt: 'cimb',
    name: 'CIMB Niaga',
    isShow: true,
    xenditChannelCode: 'CIMB',
  },
  citi: {
    src: '/assets/bank/citi.png',
    alt: 'citi',
    name: 'Citibank',
    isShow: false,
    xenditChannelCode: null,
  },
  dana: {
    src: '/assets/bank/dana.png',
    alt: 'dana',
    name: 'DANA',
    isShow: false,
    xenditChannelCode: null,
  },
  danamon: {
    src: '/assets/bank/danamon.png',
    alt: 'danamon',
    name: 'Bank Danamon',
    isShow: false,
    xenditChannelCode: null,
  },
  digibank: {
    src: '/assets/bank/digibank.png',
    alt: 'digibank',
    name: 'Digibank',
    isShow: false,
    xenditChannelCode: null,
  },
  flip: {
    src: '/assets/bank/flip.png',
    alt: 'flip',
    name: 'Flip',
    isShow: false,
    xenditChannelCode: null,
  },
  gopay: {
    src: '/assets/bank/gopay.png',
    alt: 'gopay',
    name: 'GoPay',
    isShow: false,
    xenditChannelCode: 'GOPAY',
  },
  gpay: {
    src: '/assets/bank/gpay.png',
    alt: 'gpay',
    name: 'Google Pay',
    isShow: false,
    xenditChannelCode: null,
  },
  hsbc: {
    src: '/assets/bank/hsbc.png',
    alt: 'hsbc',
    name: 'Bank HSBC',
    isShow: false,
    xenditChannelCode: null,
  },
  jago: {
    src: '/assets/bank/jago.png',
    alt: 'jago',
    name: 'Bank JAGO',
    isShow: false,
    xenditChannelCode: null,
  },
  jenius: {
    src: '/assets/bank/jenius.png',
    alt: 'jenius',
    name: 'Bank Jenius',
    isShow: false,
    xenditChannelCode: null,
  },
  kudo: {
    src: '/assets/bank/kudo.png',
    alt: 'kudo',
    name: 'Kudo',
    isShow: false,
    xenditChannelCode: null,
  },
  linkaja: {
    src: '/assets/bank/linkaja.png',
    alt: 'linkaja',
    name: 'LinkAja',
    isShow: false,
    xenditChannelCode: null,
  },
  mandiri: {
    src: '/assets/bank/mandiri.png',
    alt: 'mandiri',
    name: 'Mandiri',
    isShow: true,
    xenditChannelCode: 'MANDIRI',
  },
  maybank: {
    src: '/assets/bank/maybank.png',
    alt: 'maybank',
    name: 'Maybank',
    isShow: false,
    xenditChannelCode: null,
  },
  mega: {
    src: '/assets/bank/mega.png',
    alt: 'mega',
    name: 'Bank Mega',
    isShow: false,
    xenditChannelCode: null,
  },
  ocbc: {
    src: '/assets/bank/ocbc.png',
    alt: 'ocbc',
    name: 'Bank OCBC',
    isShow: false,
    xenditChannelCode: null,
  },
  ovo: {
    src: '/assets/bank/ovo.png',
    alt: 'ovo',
    name: 'OVO',
    isShow: false,
    xenditChannelCode: 'OVO',
  },
  panin: {
    src: '/assets/bank/panin.png',
    alt: 'panin',
    name: 'Bank Panin',
    isShow: false,
    xenditChannelCode: null,
  },
  payfazz: {
    src: '/assets/bank/payfazz.png',
    alt: 'payfazz',
    name: 'Payfazz',
    isShow: false,
    xenditChannelCode: null,
  },
  paypal: {
    src: '/assets/bank/paypal.png',
    alt: 'paypal',
    name: 'Paypal',
    isShow: false,
    xenditChannelCode: null,
  },
  paypro: {
    src: '/assets/bank/paypro.png',
    alt: 'paypro',
    name: 'PayPro',
    isShow: false,
    xenditChannelCode: null,
  },
  payren: {
    src: '/assets/bank/paytren.png',
    alt: 'payren',
    name: 'Paytren',
    isShow: false,
    xenditChannelCode: null,
  },
  permata: {
    src: '/assets/bank/permata.png',
    alt: 'permata',
    name: 'Bank Permata',
    isShow: false,
    xenditChannelCode: null,
  },
  shopeepay: {
    src: '/assets/bank/shopeepay.png',
    alt: 'shopeepay',
    name: 'Shopee Pay',
    isShow: false,
    xenditChannelCode: null,
  },
  standard_chartered: {
    src: '/assets/bank/standard_chartered.png',
    alt: 'standard_chartered',
    name: 'Standard Chartered',
    isShow: false,
    xenditChannelCode: null,
  },
  uangku: {
    src: '/assets/bank/uangku.png',
    alt: 'uangku',
    name: 'Uangku',
    isShow: false,
    xenditChannelCode: null,
  },
  uob: {
    src: '/assets/bank/uob.png',
    alt: 'uob',
    name: 'Bank UOB',
    isShow: false,
    xenditChannelCode: null,
  },
  unknown: {
    src: '/assets/bank/unknown.png',
    alt: 'unknown',
    name: 'Bank Unknown',
    isShow: false,
    xenditChannelCode: null,
  },
}

export default bankList
